import { inject, Injectable } from '@angular/core';
import { urlJoin } from '../../core/helpers/url.helper';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import { catchError, map, Observable, throwError } from 'rxjs';
import { JWTTokenResponse } from '../pages/leads/leads.component.model';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private readonly httpClient = inject(HttpClient);
  private readonly appConfig = inject(AppConfig);

  private readonly url = urlJoin(this.appConfig.url, 'authentication');

  generateInternalToken(externalId: string): Observable<string> {
    return this.httpClient.get<JWTTokenResponse>(urlJoin(this.url, 'token', externalId)).pipe(
      map(response => {
        return response?.accessToken ? response.accessToken : '';
      }),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }
}
